<template>
  <div class="page" :style="bgStyle">
    <div class="contenido">
      <p class="subtitulo">Encuesta de satisfacción</p>
      <img
        src="/mexa/boton-descarga-encuesta.png"
        class="btn-img"
        :class="{ cargando: loading }"
        alt="Descargar reporte"
        @click="!loading && descargar()"
      />
      <p v-if="loading" class="loading-msg">Descargando...</p>
      <p v-if="error" class="error-msg">{{ error }}</p>

      <!-- Indicadores -->
      <div class="metricas">
        <div class="metrica-card">
          <span class="metrica-numero">{{ metricas.vistas_video }}</span>
          <span class="metrica-label">Reproducciones de video</span>
        </div>
        <div class="metrica-card">
          <span class="metrica-numero">{{ metricas.descargas_foto }}</span>
          <span class="metrica-label">Descargas de foto</span>
        </div>
        <div class="metrica-card">
          <span class="metrica-numero">{{ metricas.encuestas }}</span>
          <span class="metrica-label">Encuestas contestadas</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EncuestaReporte',
  data() {
    return {
      loading: false, error: '', isMobile: window.innerWidth <= 768,
      metricas: { vistas_video: 0, descargas_foto: 0, encuestas: 0 }
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-encuesta.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#009fe3'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', () => { this.isMobile = window.innerWidth <= 768 })
    this.cargarMetricas()
  },
  beforeDestroy() { window.removeEventListener('resize', () => {}) },
  methods: {
    async cargarMetricas() {
      try {
        const [met, enc] = await Promise.all([
          this.$api.get('metricas-convencion26/totales'),
          this.$api.get('encuesta-convencion26/total')
        ])
        this.metricas.vistas_video = met.data.vistas_video
        this.metricas.descargas_foto = met.data.descargas_foto
        this.metricas.encuestas = enc.data.total
      } catch { /* silencioso */ }
    },
    async descargar() {
      this.loading = true
      this.error = ''
      try {
        const res = await this.$api.get('encuesta-convencion26/excel', { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = 'reporte-encuesta-convencion26.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch {
        this.error = 'Error al descargar el reporte. Intenta de nuevo.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contenido {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: clamp(260px, 45vh, 460px);
  padding-left: 6%;
  gap: 16px;
}

.subtitulo {
  color: rgba(255,255,255,0.92);
  font-size: clamp(16px, 2vw, 22px);
  font-family: TelefonicaRegular, sans-serif;
  margin: 0;
}

.btn-img {
  height: clamp(48px, 6vw, 64px);
  width: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
}
.btn-img:hover    { transform: scale(1.05); filter: brightness(1.1); }
.btn-img:active   { transform: scale(0.97); }
.btn-img.cargando { opacity: 0.6; cursor: not-allowed; }

.loading-msg { color: rgba(255,255,255,0.85); font-size: 13px; margin: 0; }
.error-msg   { color: #fff; font-size: 13px; margin: 0; }

/* Métricas */
.metricas {
  display: flex;
  gap: 20px;
  margin-top: 24px;
  flex-wrap: wrap;
  justify-content: center;
}
.metrica-card {
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 20px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 160px;
}
.metrica-numero {
  color: #fff;
  font-size: clamp(28px, 4vw, 42px);
  font-weight: bold;
  font-family: TelefonicaRegular, sans-serif;
}
.metrica-label {
  color: rgba(255,255,255,0.85);
  font-size: clamp(11px, 1.2vw, 14px);
  font-family: TelefonicaRegular, sans-serif;
  text-align: center;
}

/* TABLET */
@media (max-width: 1200px) {
  .contenido { padding-top: 270px; }
}

/* MOBILE */
@media (max-width: 768px) {
  .contenido  { padding-top: clamp(160px, 42vh, 280px); }
  .subtitulo  { font-size: 16px; }
  .btn-img    { height: 52px; }
  .metricas   { flex-direction: column; gap: 12px; align-items: center; }
  .metrica-card { min-width: 200px; padding: 16px 24px; }
}
</style>
